<div
  class="spinner"
  *ngIf="isLoading"
  [ngStyle]="{'height.px': spinnerHeight}"
>
  <mat-spinner mode="indeterminate" strokeWidth="5" [diameter]="diameter"></mat-spinner>
</div>
